export default __webpack_public_path__ + "static/Wealthi_logo-f90ac387a460f8ad9a5352da9cff600f.png";